import Component from '@glimmer/component';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

type IconArgs = {
  name: string;
  class?: string;
  svgClass?: string;
  width?: number | string;
  height?: number | string;
  viewBox?: string;
  fillCurrent?: boolean;
};

export default class Icon extends Component<IconArgs> {
  get iconName(): string {
    return this.args.name;
  }

  get cssClass(): string | undefined {
    return this.args.class;
  }

  get svgClass(): string | undefined {
    return this.args.svgClass;
  }

  get width(): number | string | undefined {
    return this.args.width;
  }

  get height(): number | string | undefined {
    return this.args.height;
  }

  get viewBox(): string | undefined {
    return this.args.viewBox;
  }

  get fillCurrent(): boolean {
    return this.args.fillCurrent !== undefined
      ? Boolean(this.args.fillCurrent)
      : true;
  }



  get containerClass(): string {
    return [
      'inline-flex justify-center max-w-full max-h-full',
      '[&_svg]:[shape-rendering:geometricprecision]',
      '[&[data-fill-current]_svg]:[fill:currentColor]',
      '[&[data-fill-current]_svg_path:not(:first-child)]:[fill:currentColor_!important]',
    ].join(' ');
  }

  <template>
    <span class={{this.containerClass}} data-fill-current={{this.fillCurrent}} ...attributes>
      {{svgJar this.iconName class=this.svgClass}}
    </span>
  </template>
}
